import { GroupConfig } from './types/pie-chart.config.js';

export const defaultGrouping: GroupConfig = {
  threshold: { type: 'relative', value: 2 },
};
